
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { ApiCallPost } from '../ApiCall/ApiCall';

export default function ReviewDetailData( { record }) {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        //ProductService.getProductsMini().then(data => setProducts(data));

        if ( record === null )
        {
            return ;
        }

        ApiCallPost( "icciddetail" , record)
        .then((response) => {
            console.log( "response = " , response )

            var nRecargas = 0 ;
            var index = 0 ;

            for( var i = 0 ; i < response.data.length ; i++ )
            {

                response.data[i].index = ++index ;

                response.data[i].numero =  response.master.numero ;

                // response.data[i].fechaactivacion = getFormatDate( response.data[i].fechaactivacion ).substring( 0 , 10 )
                // response.data[i].fechaexpiracion = getFormatDate( response.data[i].fechaexpiracion ).substring( 0 , 10 )
                // response.data[i].fechaprimerevento = getFormatDate( response.data[i].fechaprimerevento ).substring( 0 , 20 )

                response.data[i].fechaactivacion = new Date( response.data[i].fechaactivacion )

                response.data[i].fechaactivacion = addHoursToDate(response.data[i].fechaactivacion , 6); 

                response.data[i].fechaactivacion = getFormatDateShort( response.data[i].fechaactivacion ) 


                if (   ! isDate( new Date( response.data[i].fechaexpiracion ) ) )
                {
                    console.log( "isNan ********************************" , response.data[i].fechaexpiracion ) ;
                    response.data[i].fechaexpiracion = response.master.fechaexpiracion ;

                    console.log( "Lo dejamos en : " + response.data[i].fechaexpiracion )
                }
                

/*
                response.data[i].fechaexpiracion = new Date( response.data[i].fechaexpiracion )
                response.data[i].fechaexpiracion = addHoursToDate(response.data[i].fechaexpiracion , 6);
                response.data[i].fechaexpiracion = getFormatDateShort( response.data[i].fechaexpiracion )
*/

                if ( response.data[i].fechaprimerevento !== null )
                {

                    if ( response.data[i].fechaprimerevento === '0000-00-00 00:00:00')
                    {
                        response.data[i].fechaprimerevento = null ;
                        
                    }
                    else{
                        response.data[i].fechaprimerevento = new Date( response.data[i].fechaprimerevento )
                        response.data[i].fechaprimerevento = addHoursToDate(response.data[i].fechaprimerevento , 6);
                        response.data[i].fechaprimerevento = ( response.data[i].fechaprimerevento === null || response.data[i].fechaprimerevento === undefined || isNaN( response.data[i].fechaprimerevento )? null : getFormatDateShort( response.data[i].fechaprimerevento ) ) 

                    }


                }

                response.data[i].fechaexpiracion = ( response.data[i].fechaexpiracion === null || response.data[i].fechaexpiracion === undefined  )? null : getFormatDateShort( response.data[i].fechaexpiracion  ) 

                


                nRecargas = buildData( response.data[i] , response.master  , nRecargas  , ( i> 0 ? response.data[i-1] : null)) ;


 
                // response.data[i].fechaprimerrecarga = ( response.master.fechaprimerrecarga === null ? null : getFormatDate( response.master.fechaprimerrecarga ).substring( 0 , 20 ))

                response.data[i].fechaprimerrecarga = ( response.master.fechaprimerrecarga === null ? null : getFormatDateShort( response.master.fechaprimerrecarga ) ) 
    
                console.log( "fechaprimerrecarga = **" , response.data[i].fechaprimerrecarga ) ;


                console.log( "response.master.diasrecargados = " , response.master.diasrecargados)


                //response.data[i].diasrecargados = response.master.diasrecargados 
                //response.data[i].saldo = response.master.saldo 
                response.data[i].saldo = response.data[i].saldoultimarecarga 
                response.data[i].timestamp = getFormatDate( response.data[i].dTimeStamp ).substring( 0 , 20 )


                if ( response.data[i].feechaultimarecarga !== null )
                {
                    response.data[i].feechaultimarecarga = getFormatDate( response.data[i].feechaultimarecarga ).substring( 0 , 10 )
                }
                else{
                    response.data[i].diasrecargados = 0 ;
                }

                
              
            }

            console.log( "view data = " , response.data )
            
            setProducts( response.data ) ;
        })
        .catch((err) => {
            console.log( err ) ;
        })

    }, []);


    function isDate( date )
    {
        if (date instanceof Date && !isNaN(date)) { // isNaN wont accept a date in typescript, use date.getTime() instead to produce a number
            console.log("is date!!!!!!!!!!!!!!!!!!!!!!!!");
            return true ;
        }
        console.log("not is date!!!!!!!!!!!!!!!!!!!!!!!!");
        return false ;
    }


    function buildData( data  , master , nRecargas  , dataPrev)
    {

        console.log( 'master.fechaprimerrecarga = ' , master.fechaprimerrecarga )

        console.log( 'data.fechaexpiracion = ' , data.fechaexpiracion )

        if ( master.fechaexpiracion !== null )
        {

            console.log( "Calculando ...")
            master.fechaprimerrecarga = addDays( new Date( master.fechaexpiracion ) ,  -28 ) 

            console.log( "Despues de calcuylar ..." , master.fechaprimerrecarga)

        }




        if ( dataPrev != null )
        {
            if ( getDaysDifference(data.fechaexpiracion , dataPrev.fechaexpiracion ) !== 0 )
            {
                nRecargas ++ ;
            }

            data.diasrecargados =  getDaysDifference( dataPrev.fechaexpiracion  , data.fechaexpiracion ) // data.fechaexpiracion - dataPrev.fechaexpiracion 
            master.diasrecargados  = data.diasrecargados
        }


        console.log( "fechaultimarecarga ================" , data.fechaultimarecarga )

        data.fechaultimarecarga = data.fechaexpiracion


        //console.log( "fecha ultima recarga ================" , data.fechaultimarecarga )

        master.numeroderecargas = nRecargas ;

        master.fechaultimarecarga = data.fechaultimarecarga 

        // Fecha Expiracion Nueva - Fecha de Expiracion Anterior

        return nRecargas ;

    }


    function getDaysDifference(startDate, endDate) {
        let start = new Date(startDate);
        let end = new Date(endDate);
        let timeDifference = end - start;
        let daysDifference = timeDifference / (1000 * 3600 * 24);

        console.log( "datsDifference = " , daysDifference )

        return daysDifference;
    }


    // function getDaysDifference(date1, date2) {
    //     const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    //     const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    //     return daysDiff;
    //   }

    function addDays(date, days) {

        console.log( "entrando ---")

        var result = new Date(date);
        result.setDate(result.getDate() + days);

        console.log( "result = " , result )

        return result;
      }


    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
          ("00" + date.getHours()).slice(-2) + ":" +
          ("00" + date.getMinutes()).slice(-2) + ":" +
          ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
      
        return dateStr;
      }

      function getFormatDateShort(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2)  
 
        //console.log(dateStr);
      
        return dateStr;
      }


      function addHoursToDate(date, hours) {

        //console.log( "type = " , typeof( date ))

        return new Date(date.getTime() + hours * 60 * 60 * 1000);
    }



    return (
        <div className="card">
            <DataTable value={products} tableStyle={{ minWidth: '50rem' }}>
                <Column field="index" header="Index"></Column>
                 <Column field="id" header="Id"></Column>
                 <Column field="numero" header="Telefono"></Column>
                 <Column field="fechaactivacion" header="Fecha Activación"></Column>
                 <Column field="iccid" header="Imei"></Column>
                 <Column field="ofertaprimaria" header="Oferta Primaria"></Column>
                 <Column field="estatus" header="Estatus"></Column>
                 <Column field="fechaprimerevento" header="Fecha Primer Evento"></Column>
                 <Column field="fechaexpiracion" header="Fecha Expiración"></Column>

                <Column field="fechaprimerrecarga" header="Fecha primer Recarga"></Column>
                <Column field="numeroderecargas" header="Número de Recargas"></Column>
                <Column field="feechaultimarecarga" header="Fecha última Recarga"></Column>
                <Column field="diasrecargados" header="Dias Recargados"></Column>
                <Column field="saldo" header="Saldo"></Column>
                <Column field="timestamp" header="Fecha Proceso"></Column>
            </DataTable>
        </div>
    );
}
        